import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BasicLayoutComponent } from '../../components/common/layouts/basicLayout.component';
import { UsuarioAutenticadoGuard } from '../../core/guards/usuario-autenticado.guard';
import { AltaPersonalComponent } from './alta-personal/alta-personal.component';
import { PersonalComponent } from './personal.component';
import { PersonalListComponent } from './personalList/personal-list.component';
import { ReporteConstanciaFiltComponent } from './reportesPersonal/reporteConstancia/reporte-constancia-filt.component';
import { ImportacionDatosComponent } from './importacion-datos/importacion-datos.component';
import { FichaMedicaListComponent } from './fichaMedica/ficha-medica-list/ficha-medica-list.component';

const routes: Routes = [
  {
    path: 'alta',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: AltaPersonalComponent,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'gestionar',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: PersonalComponent
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'fichaMedica',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: FichaMedicaListComponent
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'listaPersonas',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: PersonalListComponent
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'impresionConstancia',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: ReporteConstanciaFiltComponent
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'importacionPersonal',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: ImportacionDatosComponent
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PersonalRoutingModule { }
